// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdownTimer {
  margin: 0 auto;
  /* z-index: 10000; */
  width: 118px;
  position: relative;
}

.dropdownTimer,
.dropdownTimer * {
  /* z-index: 10; */
  background-color: #fff;
  position: relative;
}

.dropdownTimer .dropdownTimer-btn {
  height: 39px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 10px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 11px;
  color: #4f4f4f;
  font-weight: 400;
  line-height: 26px;
  font-family: "Open Sans";
  font-style: normal;
  font-size: 16px;
  z-index: 10;
}

.dropdownTimer-content {
  position: absolute;
  font-weight: 400;
  left: 0;
  width: 100%;
  overflow-y: auto;
  height: 300px;
  box-shadow: 0 0 10px 5px rgba(40, 38, 38, 0.07);
  line-height: 26px;
  font-size: 16px;
  color: #4f4f4f;
  font-family: "Open Sans";
  font-style: normal;
  z-index: 1000;
}

.dropdownTimer-content .itemTimer {
  padding: 5px;
  cursor: pointer;
}

.dropdownTimer-content .itemTimer:hover {
  background: #c8175d;
}

.css-19midj6 {
  padding: 10px !important;
}

.css-le99rq-MuiList-root {
  width: 100% !important;
  max-width: none !important;
  min-width: 136px !important;
}

.css-17vbkzs-MuiFormControl-root-MuiTextField-root {
  margin-top: 8px !important;
}

.css-1rv3ei8-MuiFormControl-root-MuiTextField-root {
  margin-top: 8px !important;
  width: 216px !important;
}

.css-1tl47u6 {
  margin: 8px 0px 8px !important;
}`, "",{"version":3,"sources":["webpack://./src/layout/timeDropDown.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;AACJ;;AACA;;EAEI,iBAAA;EAEA,sBAAA;EACA,kBAAA;AACJ;;AACA;EACI,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAEJ;;AAAA;EACI,kBAAA;EACA,gBAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,+CAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;AAGJ;;AADA;EACI,YAAA;EACA,eAAA;AAIJ;;AAFA;EACI,mBAAA;AAKJ;;AAIA;EACI,wBAAA;AADJ;;AAGA;EACI,sBAAA;EACA,0BAAA;EACA,2BAAA;AAAJ;;AAKA;EACI,0BAAA;AAFJ;;AAIA;EACI,0BAAA;EACA,uBAAA;AADJ;;AAGA;EACI,8BAAA;AAAJ","sourcesContent":[".dropdownTimer {\n    margin: 0 auto;\n    /* z-index: 10000; */\n    width: 118px;\n    position: relative;\n}\n.dropdownTimer,\n.dropdownTimer * {\n    /* z-index: 10; */\n\n    background-color: #fff;\n    position: relative;\n}\n.dropdownTimer .dropdownTimer-btn {\n    height: 39px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    padding: 10px;\n    background: white;\n    border: 1px solid #ddd;\n    border-radius: 11px;\n    color: #4f4f4f;\n    font-weight: 400;\n    line-height: 26px;\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-size: 16px;\n    z-index: 10;\n}\n.dropdownTimer-content {\n    position: absolute;\n    font-weight: 400;\n    left: 0;\n    width: 100%;\n    overflow-y: auto;\n    height: 300px;\n    box-shadow: 0 0 10px 5px rgba(40, 38, 38, 0.07);\n    line-height: 26px;\n    font-size: 16px;\n    color: #4f4f4f;\n    font-family: 'Open Sans';\n    font-style: normal;\n    z-index: 1000;\n}\n.dropdownTimer-content .itemTimer {\n    padding: 5px;\n    cursor: pointer;\n}\n.dropdownTimer-content .itemTimer:hover {\n    background: #c8175d;\n}\n.sidebarIcon:hover {\n    // color: #ff9922 !important;\n}\n.css-qmi47k-MuiTypography-root {\n    // color: #364152 !important;\n}\n\n.css-19midj6 {\n    padding: 10px !important;\n}\n.css-le99rq-MuiList-root {\n    width: 100% !important;\n    max-width: none !important;\n    min-width: 136px !important;\n}\n.css-105kjsu-MuiButtonBase-root-MuiListItemButton-root:hover {\n    // padding: 2px 2px 2px 11px;\n}\n.css-17vbkzs-MuiFormControl-root-MuiTextField-root {\n    margin-top: 8px !important;\n}\n.css-1rv3ei8-MuiFormControl-root-MuiTextField-root {\n    margin-top: 8px !important;\n    width: 216px !important;\n}\n.css-1tl47u6 {\n    margin: 8px 0px 8px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
